import { render, staticRenderFns } from "./user-org-list.vue?vue&type=template&id=1802b4d2&"
import script from "./user-org-list.vue?vue&type=script&lang=js&"
export * from "./user-org-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports